import React from 'react'
import bart from './Bart.jpeg'

function Home() {
  return (
    <>
       <div className='hdivs'>
      <h1>
        <span className='title'>H</span>
        <span className='title'>e</span>
        <span className='title'>l</span>
        <span className='title'>l</span>
        <span className='title'>o</span>
        
        <br/>
        <span className='title'>I</span>
        <span className='title'>'</span>
        <span className='title'>m</span>
        <span className='title'> </span>
        <span className='title'>I</span>
        <span className='title'>k</span>
      </h1>
      <h3>Community manager | Junior Front End Dev</h3>
    </div>
    <img src={bart} alt='Bart'/>
    </>
  )
}

export default Home
